import { useQuery } from '@tanstack/react-query';
import axios from '../../../utils/axios';

export const useCompany = (company) => {

  return useQuery({
    enabled: !!company,
    queryKey: ['company', company],
    queryFn: async () => {
      const encodedCompany = encodeURIComponent(company);
      const result = await axios.get(`/companies/${encodedCompany}`)
      return result.data.record
    },
    refetchOnWindowFocus: false
  });
};
